
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9987_8037)"}},[_c('path',{attrs:{"d":"M19.67 19.68h-3.42v-5.36c0-1.28-.03-2.92-1.78-2.92s-2.06 1.39-2.06 2.83v5.45H9V8.66h3.28v1.5h.04a3.594 3.594 0 013.24-1.78c3.46 0 4.1 2.28 4.1 5.25v6.05h.01zM5.13 7.15c-1.1 0-1.99-.89-1.98-1.99 0-1.1.89-1.99 1.99-1.98 1.1 0 1.99.89 1.98 1.99 0 1.1-.89 1.98-1.98 1.98h-.01zm1.71 12.52H3.41V8.65h3.43v11.02zM21.38 0H1.7C.77 0 .01.73 0 1.66v19.76c.01.93.77 1.67 1.7 1.66h19.68c.93.01 1.7-.73 1.71-1.66V1.66C23.08.73 22.31-.01 21.38 0z","fill":"#1F4053"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9987_8037"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h23.09v23.09H0z"}})])])])
          )
        }
      }
    